// A small number of partner organizations (e.g. njonnuri) are onboarded via a
// fixed referral shortcut instead of a per-invite row in the `referrals` DB
// table. Centralized here so every entry point that recognizes this
// shortcut — a `?code=njonnuri` URL query param (loginOverlay.vue) or typing
// it directly into the referral code field (ReferralCodePage.vue) — treats
// it identically, rather than only one of them knowing about it.
export const NJONNURI_BYPASS_CODE = 'njonnuri';
export const NJONNURI_BYPASS_ROLE = 'Teacher';

export function isNjonnuriBypassCode(code) {
    return String(code || '').trim().toLowerCase() === NJONNURI_BYPASS_CODE;
}
